import React, { useState,useContext } from "react";
import Tabs from "@mui/material/Tabs";
import AuthContext from "../Context/AuthProvider";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid2 from "@mui/material/Grid2";
import BillList from "./BillList";
import NewService from "./NewBill";
import EditBill from "./EditBill";
import AdvancePayment from "./AdvancePayment";
import PatientVisitPopup from "./PatientVisitPopup";
import NewBill from "./NewBill";
import dayjs from "dayjs";
import { getBillById } from "../API/BillingApi";

function BillHome() {
  const [value, setValue] = useState("BillList");
  const authContext = useContext(AuthContext);
    const { auth } = useContext(AuthContext);
  const [tabs, setTabs] = useState([
    { label: "Bills", value: "BillList" },
  
  ]);
  const [openPatientVisitPopup, setOpenPatientVisitPopup] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCloseTab = (tabValue) => {
    if (tabValue === "BillList" || tabValue === "AdvancePayment") return; // Prevent closing fixed tabs
    setTabs((prevTabs) => prevTabs.filter((tab) => tab.value !== tabValue));
    if (value === tabValue) {
      setValue("BillList");
    }
  };

  
  const handleEditDetails = async (row) => {
    const existingTab = tabs.find((tab) => tab.value === `EditBill-${row.id}`);
    if (existingTab) {
      setValue(existingTab.value);
      return;
    }
  
    try {
      const billId = row.id;
      const displayId= row.displayId;
     
  
      const newTab = {
        label: `Edit Bill - ${row.patientName}`,
        value: `EditBill-${row.id}`,
        content: <NewBill billId={billId} />,
      };
  
      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue(newTab.value);
    } catch (error) {
      console.error("Error fetching data for Edit Bill", error);
    }
  };
  // Open Patient Visit Popup when clicking "New Bill"
  const handleNewBill = () => {
    setOpenPatientVisitPopup(true);
  };

  // Open a new bill with visitId from selected patient
  const handleVisitSelectedForNewBill = (newBillInfo) => {
    console.log("New Bill Info:", newBillInfo); // Debugging step
  
    const formattedDate = newBillInfo?.createdOn
      ? dayjs(newBillInfo.createdOn).format("YYYY/MM/DD")
      : newBillInfo?.createdDate
      ? dayjs(newBillInfo.createdDate).format("YYYY/MM/DD")
      : "N/A"; 
  
    const newTab = {
      label: `${newBillInfo.displayId} - ${newBillInfo.patientFirstName} ${newBillInfo.patientLastName}`,
      value: `Bill-${newBillInfo.id}`,
      content: (
        <NewBill
          newBillInfo={{
            ...newBillInfo,
            createdOn: formattedDate,
             editMode: false, 
          }}
        />
      ),
    };
  
    setTabs((prevTabs) => [...prevTabs, newTab]);
    setValue(newTab.value);
    setOpenPatientVisitPopup(false);
  };
  // Open an existing bill dynamically
  const handleOpenBill = (billNo) => {
    const existingTab = tabs.find((tab) => tab.value === `Bill-${billNo}`);
    if (existingTab) {
      setValue(existingTab.value);
      return;
    }

    const newTab = {
      label: `Bill ${billNo}`,
      value: `Bill-${billNo}`,
      content: <div>Content for Bill {billNo}</div>, // Replace with actual bill component
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setValue(newTab.value);
  };

  return (
    <Grid2 container>
      <TabContext value={value}>
        <Grid2 size={12}>
          <Tabs value={value} onChange={handleChange} variant="scrollable">
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={
                  <Grid2 container alignItems="center">
                    {tab.label}
                    {tab.value !== "BillList" && tab.value !== "AdvancePayment" && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCloseTab(tab.value);
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Grid2>
                }
                value={tab.value}
              />
            ))}
          </Tabs>
        </Grid2>

        {tabs.map((tab) => (
          <TabPanel key={tab.value} value={tab.value} sx={{ padding: "0px", width: "100%" }}>
            {tab.value === "BillList" && (
              <BillList
                //onNewService={handleNewService}
                onEditDetails={handleEditDetails}
                onNewBill={handleNewBill} // Opens PatientVisitPopup
              />
            )}
            {tab.value === "AdvancePayment" && <AdvancePayment />}
            {tab.value !== "BillList" && tab.value !== "AdvancePayment" && tab.content}
          </TabPanel>
        ))}
      </TabContext>

      {/* Patient Visit Popup */}
      <PatientVisitPopup
        open={openPatientVisitPopup}
        onClose={() => setOpenPatientVisitPopup(false)}
        onVisitSelected={handleVisitSelectedForNewBill} // Pass visitId to create a new bill
        onOpenBill={handleOpenBill} // Pass to open existing bills
      />
    </Grid2>
  );
}

export default BillHome;